import axios from 'axios';
import { useQuery } from 'react-query';

const useGetStandardizationProjects = () => {
  const { data, isLoading, isRefetching } = useQuery(
    'standardizationProjects',
    async () => {
      const projects = (await axios.get('/standardization/?archived=false')).data;

      return projects.map((project) => ({
        ...project,
      }));
    },
    { refetchOnMount: true }
  );

  return {
    standardizationProjects: data,
    isLoading: isLoading || isRefetching,
  };
};

export default useGetStandardizationProjects;
